// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__zTWLN","errorLogs":"styles_errorLogs__3FRWI"};